import { OfficeIcon } from "components/icons/v2/Office";
import ReactCountryFlag from "react-country-flag";

type AvatarSize = "xs" | "sm" | "md" | "lg";
type AvatarShape = "rect" | "circle";

type EntityFlagAvatarProps = {
  countryCode?: string;
  size?: AvatarSize;
  shape?: AvatarShape;
};

// rectangular flag sizes (~3:2) and square (circle) sizes
const RECT_DIMENSIONS: Record<AvatarSize, { width: string; height: string }> = {
  xs: { width: "0.875rem", height: "0.625rem" },
  sm: { width: "1.5rem", height: "1rem" },
  md: { width: "1.75rem", height: "1.25rem" },
  lg: { width: "2.25rem", height: "1.5rem" },
};

const SQUARE_DIMENSION: Record<AvatarSize, string> = {
  xs: "0.875rem",
  sm: "1.5rem",
  md: "1.75rem",
  lg: "2.25rem",
};

const RECT_CLASS: Record<AvatarSize, string> = {
  xs: "t-h-2.5 t-w-3.5",
  sm: "t-h-4 t-w-6",
  md: "t-h-5 t-w-7",
  lg: "t-h-6 t-w-9",
};

const SQUARE_CLASS: Record<AvatarSize, string> = {
  xs: "t-h-3.5 t-w-3.5",
  sm: "t-h-6 t-w-6",
  md: "t-h-7 t-w-7",
  lg: "t-h-9 t-w-9",
};

export const EntityFlagAvatar = ({
  countryCode,
  size = "md",
  shape = "rect",
}: EntityFlagAvatarProps) => {
  const isCircle = shape === "circle";
  const radiusClass = isCircle ? "t-rounded-full" : "t-rounded-sm";

  if (countryCode) {
    const dimension = isCircle
      ? { width: SQUARE_DIMENSION[size], height: SQUARE_DIMENSION[size] }
      : RECT_DIMENSIONS[size];

    return (
      <ReactCountryFlag
        countryCode={countryCode}
        svg
        title={countryCode}
        className={`t-shrink-0 ${radiusClass}`}
        style={{
          width: dimension.width,
          height: dimension.height,
          objectFit: "cover",
        }}
      />
    );
  }

  const boxClass = isCircle ? SQUARE_CLASS[size] : RECT_CLASS[size];

  return (
    <span
      className={`t-flex t-shrink-0 t-items-center t-justify-center t-bg-surface-purple t-text-purple-70 ${radiusClass} ${boxClass}`}
    >
      <OfficeIcon />
    </span>
  );
};
